import { use } from 'react';
import { LoansContext } from '@/context/loans-context-definition';

export function useLoans() {
  const context = use(LoansContext);
  if (context === undefined) {
    throw new Error('useLoans must be used within a LoansProvider');
  }
  return context;
}
